import type { FC } from 'react';
import { ReactEditor, useSlate } from 'slate-react';

import { Icon, navigatorIsAvailable, registerIcon, useI18n } from '@pega/cosmos-react-core';
import * as indentIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/indent.icon';
import * as unindentIcon from '@pega/cosmos-react-core/lib/components/Icon/icons/unindent.icon';

import EditorCommands from '../utils/EditorCommands';

import ToolbarButton from './ToolbarButton';
import type { ToolBarButtonProps } from './ToolbarButton';
import { getKeyCommand } from './utils';

registerIcon(indentIcon, unindentIcon);

interface IndentButtonProps {
  type: 'indent' | 'unindent';
  osx: boolean;
}

const isMobile = navigatorIsAvailable && navigator.userAgent.includes('Mobile');

const IndentButton: FC<IndentButtonProps> = ({ type, osx }) => {
  const editor = useSlate();
  const t = useI18n();
  const tooltipMobile = type === 'indent' ? `${t('rte_indent')}` : `${t('rte_unindent')}`;
  const tooltipDesktop = getKeyCommand(osx, ({ shift, alt }) =>
    type === 'indent' ? `${t('rte_indent')} (${alt}M)` : `${t('rte_unindent')} (${alt}${shift}M)`
  );
  const tooltip = isMobile ? tooltipMobile : tooltipDesktop;

  const onMouseDown: ToolBarButtonProps['onMouseDown'] = e => {
    e.preventDefault();
    if (type === 'indent') {
      EditorCommands.indent(editor);
    } else {
      EditorCommands.unindent(editor);
    }
    if (!ReactEditor.isFocused(editor)) ReactEditor.focus(editor);
  };

  return (
    <ToolbarButton onMouseDown={onMouseDown} tooltip={tooltip} label={type}>
      <Icon name={type} />
    </ToolbarButton>
  );
};

export default IndentButton;
